import { render, staticRenderFns } from "./VendorContacts.vue?vue&type=template&id=2590004c&scoped=true&"
import script from "./VendorContacts.vue?vue&type=script&lang=js&"
export * from "./VendorContacts.vue?vue&type=script&lang=js&"
import style0 from "./VendorContacts.vue?vue&type=style&index=0&id=2590004c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2590004c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2590004c')) {
      api.createRecord('2590004c', component.options)
    } else {
      api.reload('2590004c', component.options)
    }
    module.hot.accept("./VendorContacts.vue?vue&type=template&id=2590004c&scoped=true&", function () {
      api.rerender('2590004c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/vendors/VendorContacts.vue"
export default component.exports